<template>
  <div class="sub-menu">
    <nav class="navbar navbar-expand navbar-light p-0">
      <ul class="navbar-nav sub-menu-nav">
        <li class="nav-item" :class="{ active: isActive('fundRaising') }">
          <div class="d-flex">
            <router-link class="nav-link" :to="{ name: 'fundRaising' }">Проектное финансирование</router-link>
          </div>

        </li>
        <li class="nav-item" :class="{ active: isActive('fundRaisingLoan') }">
          <div class="d-flex">
            <router-link class="nav-link" :to="{ name: 'fundRaisingLoan' }">Займы бизнесу</router-link>
          </div>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto mr-3">
        <li class="nav-item dropdown">
          <a class="nav-link sorting-toggle d-flex align-items-center justify-content-between"
             href="#list-filter"
             id="filter"
             role="button"
             data-toggle="collapse"
             aria-expanded="false"
          >
            Фильтры
            <span class="arrow">▼</span>
          </a>
        </li>
        <li class="nav-item dropdown position-relative" ref="sortingDropdownWrapper">
          <div
              class="sorting-toggle d-flex align-items-center justify-content-between"
              @click.prevent="toggleDropdown"
          >
            {{ selectedSortingLabel }}
            <span class="arrow" :class="{ open: dropdownOpen }">▼</span>
          </div>

          <ListSortingDropdown
              v-if="dropdownOpen"
              @close="dropdownOpen = false"
              @select="onSortingSelected"
              class="position-absolute sorting-dropdown"
          />
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import {appConfig} from "@/configs";
import PublicLink from "@/components/common/components/PublicLink.vue";
import ListSortingDropdown from "@/components/dashboard/components/invest/components/ListSortingDropdown.vue";
import {eventBus} from "@/utils/event-helper/eventBus";

export default {
  name: "SubMenu",
  components: {
    ListSortingDropdown,
    PublicLink
  },
  data() {
    return {
      guarantorFeature: appConfig.guarantorFeature,
      dropdownOpen: false,
      selectedSortingLabel: "Сортировка",
    };
  },
  methods: {
    isActive(routeName) {
      const route = this.$router.resolve({name: routeName});
      return this.$route.matched.some((item) => item.name === route.name || item.path.indexOf(route.path + '/') > -1);
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    onSortingSelected(option) {
      if (option === null) {
        this.selectedSortingLabel = "Сортировка";
      } else {
        this.selectedSortingLabel = option.label;
      }
      eventBus.emit("sorting-updated");
    },
    handleClickOutside(event) {
      const dropdown = this.$refs.sortingDropdownWrapper;
      if (dropdown && !dropdown.contains(event.target)) {
        this.dropdownOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style lang="scss">
.sub-menu {
  .navbar {
    flex-wrap: wrap;
  }

  .sub-menu-nav {
    width: 100%;
  }

  .sorting-toggle {
    border: 1px solid #e9ecef;
    border-radius: 4px;
    padding: 6px 12px;
    font-weight: 500;
    min-width: 200px;
    cursor: pointer;
    background-color: #fff;
    transition: border-color 0.2s ease;

    &:hover {
      border-color: #ced4da;
    }

    .arrow {
      margin-left: 8px;
      font-size: 0.7rem;
      transition: transform 0.2s ease;
    }

    .arrow.open {
      transform: rotate(180deg);
    }
  }

  .sorting-dropdown {
    z-index: 1000;
    margin-top: 4px;
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  }
  @media (min-width: 520px) {
    .navbar {
      flex-wrap: nowrap;
    }

    .sub-menu-nav {
      width: auto;
    }
  }


  @media (min-width: 1040px) {
    .navbar .navbar-nav .nav-item {
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }
  }

  @media (min-width: 1140px) {
    .navbar .navbar-nav .nav-item {
      margin-left: 1rem;
      margin-right: 1rem;
    }
  }
}

@media (max-width: 520px) {
  .sub-menu {
    .sorting-toggle {
     min-width: 100px;
      margin: 5px 10px;
    }
  }
}
</style>
